import { render, staticRenderFns } from "./ProductsReportView.vue?vue&type=template&id=60163d3b&scoped=true"
import script from "./ProductsReportView.vue?vue&type=script&lang=js"
export * from "./ProductsReportView.vue?vue&type=script&lang=js"
import style0 from "./ProductsReportView.vue?vue&type=style&index=0&id=60163d3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60163d3b",
  null
  
)

export default component.exports